import { DoublePipe } from './double.pipe';
import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { Utils } from '../utils';

@Pipe({ name: 'trDoubleSignus' })
@Injectable({ providedIn: 'root' })
export class DoubleSignusPipe implements PipeTransform {
  constructor(private doublePipe: DoublePipe) {}

  transform(value: number, digitsInfo?: string): string {
    if (!Utils.isValue(value)) return '--';

    let num = this.doublePipe.transform(value, digitsInfo);

    if (value > 0) {
      num = '+' + num;
    }

    return num;
  }
}
